import { createTheme } from '@mui/material/styles'

export default createTheme({
  palette: {
    primary: {
      main: "#a30e36"
    }
  }
})